import React, { useCallback, useState } from 'react';

import { IconButton } from '@mui/material';
import { Trash2 } from 'lucide-react';
import { AlineTooltip, ConfirmationDialog } from 'src/components';

export const SkillRemoveButton = React.memo(function SkillRemoveButton({
  confirm: shouldConfirm = true,
  folder = false,
  name,
  onConfirm,
}: {
  name: string;
  onConfirm: () => void;
  /** Off for an empty folder: there is nothing to lose, so no dialog to click through. */
  confirm?: boolean;
  folder?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const show = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      if (shouldConfirm) setOpen(true);
      else onConfirm();
    },
    [onConfirm, shouldConfirm]
  );
  const close = useCallback(() => setOpen(false), []);
  const confirm = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      onConfirm();
    },
    [onConfirm]
  );
  const kind = folder ? 'folder' : 'file';

  return (
    <>
      <AlineTooltip arrow placement="top" title={`Remove ${kind}`}>
        <IconButton aria-label={`Remove ${name}`} color="error" size="small" onClick={show}>
          <Trash2 size={14} />
        </IconButton>
      </AlineTooltip>
      <ConfirmationDialog
        message={`Remove “${name}”${folder ? ' and all its contents' : ''} from this skill?`}
        open={open}
        primaryText="Remove"
        title={`Remove ${kind}?`}
        onClickPrimary={confirm}
        onClose={close}
      />
    </>
  );
});
